import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyD1DCPGqHbERo-emDc50S4jEB0gfC_bS1A",
  authDomain: "hickory-construction.firebaseapp.com",
  projectId: "hickory-construction",
  storageBucket: "hickory-construction.firebasestorage.app",
  messagingSenderId: "802358367337",
  appId: "1:802358367337:web:d77e9c789a6e4ae764fef8",
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
